import AdminUpdatePasein from "../../components/AdminOdontogramRestorativeMaterial/AdminOdontogramRestorativeUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
